<template>
    <Panel title="组件配置">
        <el-form ref="form" label-position="top">
            <div style="float: right; margin-right: 3px;">
                <el-button class="blue" icon="el-icon-thumb" @click="fmt">格式化</el-button>
                <el-popover placement="top" trigger="click" style="margin-left: 3px;">
                    <div width="250px; height: 50px;" v-loading="loading">
                        {{ mouldData }}
                    </div>
                    <el-button slot="reference" class="blue" icon="el-icon-document" @click="template">配置模板</el-button>
                </el-popover>
            </div>
            <el-form-item label="配置参数" prop="data">
                <el-input v-model="data" type="textarea" :rows="12" ref="input"></el-input>
            </el-form-item>
        </el-form>
    </Panel>
</template>

<script>
import CommonApi from "@/api/Common";

export default {
    props: {
        // ukeyPassword;
        // deviceName = "USBKey";
        // hostId;
        value: {type: Object, default: () => ({})},
        uuid: {type: String, default: ''}
    },
    data: () => ({
        data: '',
        mouldData: '',
        loading: false
    }),
    mounted() {
        this.data = JSON.stringify(this.value);
    },
    watch: {
        data() {
            this.value = JSON.parse(this.data);
            this.$emit('input', this.value);
        }
    },
    methods: {
        validate() {
            return this.$refs.form.validate();
        },
        init() {
        },
        fmt() {
            try {
                let json = JSON.parse(this.data);
                this.data = JSON.stringify(json, '  ', 4);
            } catch (e) {
                this.$message.warning('JSON格式非法');
                this.$refs.input.focus();
            }
        },
        async template() {
            if (!this.uuid) {
                return;
            }
            try {
                this.loading = true;
                let respData = await CommonApi.getJsonMould(this.uuid);
                this.mouldData = respData.jsonMould || '{}';
            } finally {
                this.loading = false;
            }
        },
    }

}
</script>

<style scoped>

</style>